import style from './style.module.scss'
import classNames from 'classnames'
import { Header as HeaderText, Text } from '@crossfit/design-system'
import { ReactComponent as LockIcon } from 'components/Admin/Shared/Container/lock.svg'

type Props = {
  className?: string
  header?: string
  headerTypographyType?: 'header' | 'body'
  icon?: string
  subHeader?: string
  subHeaderComponent?: any
}

function Header({
  className,
  header,
  headerTypographyType = 'header',
  icon,
  subHeader,
  subHeaderComponent,
}: Props) {
  return (
    <div
      className={classNames(
        style.headerContainer,
        className && style[className],
        (subHeader || subHeaderComponent) && style.hasSubHeader,
      )}
    >
      <div className={style.header}>
        {icon ? (
          <div className={style.headerIcon}>
            {icon === 'lock' && <LockIcon />}
          </div>
        ) : null}
        {headerTypographyType === 'header' ? (
          <HeaderText as='h2' className={style.headerText} size='md'>
            {header}
          </HeaderText>
        ) : null}
        {headerTypographyType === 'body' ? (
          <Text
            as='p'
            type='body'
            className={style.headerBodyText}
            size='lg'
            bold
          >
            {header}
          </Text>
        ) : null}
      </div>
      {subHeader && (
        <Text
          as='div'
          type='body'
          className={style.subHeader}
          size='sm'
          dangerousHTML={subHeader}
        />
      )}
      {subHeaderComponent && subHeaderComponent}
    </div>
  )
}

export default Header
